//function for selecting tabs
export default function tabSelect(tab, setSelectedTab) {
    setSelectedTab(tab);
}
